/* updated By - Pankaj-5437
   Date: 04-Nov-2026
   start
   While a Docuverus admin is switched into a subscriber, /ats must not open
   the all-subscriber ATS and VR inbox.
   end */

export type SwitchedSubscriberStore = {
  value?: string | number | null;
} | null | undefined;

const SWITCH_SUBSCRIBER_FLAG = 'RaStore.switchSubscriber';
const SWITCH_SUBSCRIBER_NAME = 'RaStore.switchSubscriberName';

const hasSubscriberId = (value: unknown): value is string | number => {
  if (value === undefined || value === null) return false;
  return String(value).trim() !== '';
};

export const isSubscriberSwitchActive = (): boolean => {
  if (typeof localStorage === 'undefined') return false;
  return localStorage.getItem(SWITCH_SUBSCRIBER_FLAG) === 'true';
};

export const readSwitchedSubscriberId = (
  storeValue?: SwitchedSubscriberStore
): string | null => {
  if (!isSubscriberSwitchActive()) return null;

  const storeSubscriberId = storeValue?.value;
  if (hasSubscriberId(storeSubscriberId)) {
    return String(storeSubscriberId);
  }

  try {
    const raw = localStorage.getItem(SWITCH_SUBSCRIBER_NAME);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!hasSubscriberId(parsed?.value)) return null;
    return String(parsed.value);
  } catch {
    return null;
  }
};

export const switchedSubscriberInboxPath = (subscriberId: string): string =>
  `/ats/subscriber/inbox/${subscriberId}`;

export const adminSwitchNeedsRecovery = (
  subscriberView: boolean | undefined,
  storeValue?: SwitchedSubscriberStore
): boolean =>
  subscriberView === false &&
  isSubscriberSwitchActive() &&
  !readSwitchedSubscriberId(storeValue);

export const shouldSuppressAdminInbox = (
  subscriberView: boolean | undefined,
  invalidSwitchCleared = false
): boolean =>
  subscriberView === false &&
  isSubscriberSwitchActive() &&
  !invalidSwitchCleared;
